import type { CityConfig } from "../city-template/types";

export const thomasvilleConfig: CityConfig = {
  city: "Thomasville",
  state: "North Carolina",
  stateAbbr: "NC",
  slug: "thomasville",
  route: "/cities/thomasville",
  title: "Emergency Passport Thomasville, NC | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Thomasville, NC — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Davidson County and the Piedmont Triad. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Thomasville, NC",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Thomasville and Davidson County travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Thomasville%20North%20Carolina%20charming%20historic%20downtown%20main%20street%20at%20golden%20hour%20with%20vintage%20brick%20buildings%20and%20big%20chair%20landmark%20visible%2C%20small%20town%20American%20atmosphere%20with%20tree-lined%20sidewalks%20and%20well-maintained%20storefronts%2C%20warm%20sunset%20light%20over%20Davidson%20County%20community%2C%20green%20trees%20and%20historic%20architecture%20with%20Southern%20charm%2C%20professional%20cityscape%20photography%20with%20warm%20earthy%20tones%20and%20southern%20small%20town%20charm%2C%20no%20text%20or%20signs%20on%20buildings&width=1800&height=700&seq=thomasville-hero-nc-001&orientation=landscape",
  heroImageAlt: "Thomasville North Carolina charming historic downtown with vintage brick buildings and the famous big chair landmark at golden hour",
  geoPosition: "35.8859;-80.0819",
  geoPlacename: "Thomasville, North Carolina",
  regionalAgency: {
    name: "Atlanta Passport Agency",
    address: "230 Peachtree Street NW, Suite 1400, Atlanta, GA 30303",
    distance: "Located in downtown Atlanta — approximately 300 miles from Thomasville via I-85",
  },
  nearbyCitiesZips: [
    { name: "Thomasville", zips: "27360, 27361, 27362" },
    { name: "Lexington", zips: "27292, 27293, 27294, 27295" },
    { name: "High Point", zips: "27260, 27261, 27262, 27263, 27264, 27265" },
    { name: "Greensboro", zips: "27401–27499" },
    { name: "Winston-Salem", zips: "27101–27199" },
    { name: "Kernersville", zips: "27284, 27285" },
    { name: "Asheboro", zips: "27203, 27204, 27205" },
    { name: "Archdale", zips: "27263" },
    { name: "Trinity", zips: "27370" },
    { name: "Welcome", zips: "27374" },
    { name: "Denton", zips: "27239" },
    { name: "Wallburg", zips: "27373" },
    { name: "Clemmons", zips: "27012" },
    { name: "Lewisville", zips: "27023" },
    { name: "Jamestown", zips: "27282" },
    { name: "Reidsville", zips: "27320, 27321, 27323" },
    { name: "Eden", zips: "27288, 27289" },
    { name: "Burlington", zips: "27215, 27216, 27217" },
    { name: "Mebane", zips: "27302" },
    { name: "Randleman", zips: "27317" },
    { name: "Ramseur", zips: "27316" },
    { name: "Salisbury", zips: "28144, 28145, 28146, 28147" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Davidson County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Piedmont Triad Coverage", desc: "Serving Thomasville, High Point, Lexington, and the Triad region" },
  ],
  internalLinks: [
    { name: "Expedited passport services in High Point, NC", route: "/cities/high-point" },
    { name: "Fast passport renewal in Greensboro, NC", route: "/cities/greensboro" },
    { name: "Emergency passport help in Winston-Salem, NC", route: "/cities/winston-salem" },
    { name: "Urgent passport services in Kernersville, NC", route: "/cities/kernersville" },
    { name: "Same-day passport help in Asheboro, NC", route: "/cities/asheboro" },
    { name: "Passport courier services in Lexington, NC", route: "/cities/lexington" },
    { name: "Passport courier services in Salisbury, NC", route: "/cities/salisbury" },
    { name: "Fast passport renewal in Burlington, NC", route: "/cities/burlington" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Thomasville remotely via secure courier. We do not have a walk-in office in Thomasville — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Davidson County and the Piedmont Triad travelers.",
  fpcOfficeDistance: "Serving all of Davidson County and the Piedmont Triad including Guilford, Forsyth, and Randolph counties",
  serviceAreaIntro: "From the historic downtown streets of Thomasville to the furniture market district of High Point, from the quiet communities of Lexington and Archdale to the bustling corridors of Greensboro and Winston-Salem, from the suburban neighborhoods of Kernersville and Clemmons to the growing towns of Asheboro and Randleman, from the university corridors of Greensboro to the manufacturing centers of the Triad — Fast Passport Center serves the entire Thomasville region. We regularly help travelers from Davidson County, the Piedmont Triad, and central North Carolina get their passports fast.",
  nearbyCitiesIntro: "We serve all Thomasville neighborhoods and the surrounding Davidson County and Piedmont Triad area including Lexington, High Point, Greensboro, Winston-Salem, Kernersville, Asheboro, Archdale, Trinity, Welcome, Denton, Wallburg, Clemmons, Lewisville, Jamestown, Reidsville, Eden, Burlington, Mebane, Randleman, Ramseur, and Salisbury. If you are anywhere in Davidson County, Guilford County, Forsyth County, or the Piedmont Triad, we have you covered.",
  howItWorksIntro: "Most Thomasville travelers complete everything online and ship documents overnight. No need to drive to Atlanta or wait in line at the regional agency.",
  mistakesIntro: "Thomasville travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Thomasville and Davidson County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Thomasville? Here are the most common ones we hear from Davidson County travelers.",
  statePageRoute: "/states/north-carolina",
  statePageName: "North Carolina",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Thomasville international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Melissa B.",
      location: "Thomasville, NC",
      rating: 5,
      text: "My passport expired 3 days before our business trip to Paris. Fast Passport Center had my renewal ready in 26 hours. I never left Davidson County. Their expedited passport service was absolutely amazing.",
      service: "Passport Renewal",
    },
    {
      name: "Thomas G.",
      location: "Lexington, NC",
      rating: 5,
      text: "Emergency passport for a family medical emergency in London. Got it in 31 hours. Fast Passport Center handled everything — I didn't have to drive to Atlanta. Saved a family crisis.",
      service: "Emergency Passport",
    },
    {
      name: "Rachel A.",
      location: "High Point, NC",
      rating: 5,
      text: "First passport for my 10-year-old before our Europe trip. Fast Passport Center walked us through every document and had her passport in 4 days. So easy for Piedmont Triad families.",
      service: "Child Passport",
    },
    {
      name: "Kevin M.",
      location: "Kernersville, NC",
      rating: 5,
      text: "Lost my passport 2 days before a conference in Berlin. Fast Passport Center had a replacement in 29 hours. Their Triad coverage is the best for fast passport services.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "thomasville-1",
      name: "Thomasville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1112 Randolph St",
      city: "Thomasville",
      state: "NC",
      zip: "27360",
      phone: "(336) 472-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Thomasville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Thomasville facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "thomasville-2",
      name: "Lexington Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "100 W 3rd St",
      city: "Lexington",
      state: "NC",
      zip: "27292",
      phone: "(336) 248-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "8 miles west of Thomasville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Lexington and west Davidson County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "thomasville-3",
      name: "High Point Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "120 E Green Dr",
      city: "High Point",
      state: "NC",
      zip: "27260",
      phone: "(336) 884-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "15 miles northeast of Thomasville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major regional facility for High Point and Guilford County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "thomasville-4",
      name: "Greensboro Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "201 N Murrow Blvd",
      city: "Greensboro",
      state: "NC",
      zip: "27401",
      phone: "(336) 379-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "25 miles northeast of Thomasville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major regional facility for Greensboro and Guilford County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "thomasville-5",
      name: "Davidson County Clerk of Court",
      type: "Court Clerk Passport Acceptance",
      address: "110 W Center St",
      city: "Lexington",
      state: "NC",
      zip: "27292",
      phone: "(336) 242-6700",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Davidson County Courthouse, Lexington",
      website: "https://www.davidsoncountync.gov/",
      websiteLabel: "Davidson County Clerk",
      notes: "Accepts passport applications. Good alternative to post office with extended hours. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "thomasville-6",
      name: "Winston-Salem Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "251 N Main St",
      city: "Winston-Salem",
      state: "NC",
      zip: "27101",
      phone: "(336) 631-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "30 miles north of Thomasville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major regional facility for Winston-Salem and Forsyth County. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5 hour drive to Atlanta", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Thomasville photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Davidson County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Thomasville applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Davidson County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Thomasville travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Thomasville." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Thomasville address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Thomasville before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Thomasville for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 5 hour drive to Atlanta." },
    { q: "How fast can I renew my passport in Thomasville?", a: "Fast Passport Center offers fast passport renewal in Thomasville in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Thomasville?", a: "The nearest regional passport agency to Thomasville is the Atlanta Passport Agency, approximately 300 miles away via I-85. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Thomasville without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Thomasville?", a: "Same-day passport appointments are only available at the Atlanta Regional Passport Agency — approximately 5 hours from Thomasville — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Davidson County residents." },
    { q: "Do you serve the entire Piedmont Triad?", a: "Absolutely. Fast Passport Center serves the entire Piedmont Triad including Thomasville, Lexington, High Point, Greensboro, Winston-Salem, Kernersville, Asheboro, Archdale, Trinity, Clemmons, Lewisville, Jamestown, Reidsville, Eden, Burlington, Mebane, Randleman, Ramseur, and Salisbury. Our courier service works seamlessly from any address in Davidson, Guilford, Forsyth, or Randolph counties." },
    { q: "Can I expedite a child passport in Thomasville?", a: "Yes. Fast Passport Center expedites child passports in Thomasville for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Davidson County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Thomasville with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Atlanta Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Thomasville", address: "1112 Randolph St, Thomasville, NC 27360", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walmart — Thomasville", address: "1585 National Hwy, Thomasville, NC 27360", hours: "Mon–Sun: 6AM–11PM" },
    { name: "CVS Pharmacy — Lexington", address: "100 W 3rd St, Lexington, NC 27292", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — High Point", address: "120 E Green Dr, High Point, NC 27260", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Greensboro", address: "201 N Murrow Blvd, Greensboro, NC 27401", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Winston-Salem", address: "251 N Main St, Winston-Salem, NC 27101", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — Kernersville", address: "124 S Main St, Kernersville, NC 27284", hours: "Mon–Sun: 8AM–10PM" },
    { name: "FedEx Office — Greensboro", address: "202 N Elm St, Greensboro, NC 27401", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    {
      name: "NC DMV — Thomasville",
      address: "1121 E National Hwy, Thomasville, NC 27360",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "NC DMV — Lexington",
      address: "10 W Center St, Lexington, NC 27292",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Davidson County and Lexington area. REAL ID available.",
      featured: false,
    },
    {
      name: "NC DMV — High Point",
      address: "1801 N Main St, High Point, NC 27262",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Guilford County and High Point area. REAL ID available.",
      featured: true,
    },
    {
      name: "NC DMV — Greensboro",
      address: "3411 W Wendover Ave, Greensboro, NC 27407",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Guilford County and Greensboro area. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "GSO",
      name: "Piedmont Triad International Airport",
      distance: "20 miles northeast of Thomasville",
      address: "1000 Ted Johnson Pkwy, Greensboro, NC 27409",
      note: "Primary airport for the Piedmont Triad. Direct flights to major domestic hubs including New York, Chicago, and Atlanta. About 25 minutes from Thomasville.",
      flightUrl: "https://www.flyfrompti.com/",
      flightLabel: "GSO Airport",
      featured: true,
    },
    {
      code: "CLT",
      name: "Charlotte Douglas International Airport",
      distance: "60 miles southwest of Thomasville",
      address: "5501 Josh Birmingham Pkwy, Charlotte, NC 28208",
      note: "Major international hub. American Airlines hub with direct flights to Europe, Mexico, and the Caribbean. About 75 minutes from Thomasville.",
      flightUrl: "https://www.cltairport.com/",
      flightLabel: "CLT Airport",
      featured: false,
    },
    {
      code: "RDU",
      name: "Raleigh-Durham International Airport",
      distance: "80 miles east of Thomasville",
      address: "2400 John Brantley Blvd, Morrisville, NC 27560",
      note: "Major alternative hub with additional international routes. Consider for long-haul international travel from Davidson County.",
      flightUrl: "https://www.rdu.com/",
      flightLabel: "RDU Airport",
      featured: false,
    },
  ],
};